import axios from 'axios';
import Swiper, { Navigation } from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class HatboxUgc extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      content: '.js-hatBoxUgcContent',
      sizeGuideTableContainer: '.js-tableContainer',
      title: '.js-hatboxUgcTitle',
      swiperContainer: '.js-hatboxSwiperContainer',
      swiperWrapper: '.js-hatboxSwiperWrapper',
      prevBtn: '.js-hatboxSwiperPrev',
      nextBtn: '.js-hatboxSwiperNext',
    };

    this.dom = {
      $component: component,
      $title: this.$get(this.refs.title),
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $swiperWrapper: this.$get(this.refs.swiperWrapper),
      $prevBtn: this.$get(this.refs.prevBtn),
      $nextBtn: this.$get(this.refs.nextBtn),
    };

    this.state = {
      activeShape: null,
      slideContainers: null,
      swiper: null,
      setActiveUgcContentEvent: 'setactiveugccontent',
      loadActive: true,
      showClass: 'show',
      hideLoaderClass: 'hide-loader',
      animationDuration: 500,
    };

    this.mount();
  }

  mount() {
    super.mount();

    this.fetchSliderContent();
  }

  async fetchSliderContent() {
    const { dom } = this;
    const { contentPage } = dom.$component.dataset;
    const url = `/pages/${contentPage}`;

    try {
      const { data } = await axios.get(url);
      const parser = new DOMParser();
      const page = parser.parseFromString(data, 'text/html');

      this.parseContent(page);
    } catch (e) {
      console.log('Error fetching UGC content', e);
    }
  }

  parseContent(page) {
    const { refs, state } = this;
    const slideContainers = page.querySelectorAll(refs.content);

    state.slideContainers = Array.from(slideContainers)
      .map(this.parseSliderContent);

    this.getActiveShape();
  }

  parseSliderContent(container) {
    const { shape, title } = container.dataset;

    return {
      shape,
      title,
      container,
    };
  }

  getActiveShape() {
    const { dom } = this;
    const { hatboxProductShape } = dom.$component.dataset;

    if (hatboxProductShape) {
      this.setActiveShape(hatboxProductShape);
    } else {
      this.getActiveShapeSizeGuidePage();
      this.setActiveUgcContentChangeListener();
    }
  }

  getActiveShapeSizeGuidePage() {
    const { refs } = this;
    const sizeGuideTableContainer = document.querySelector(refs.sizeGuideTableContainer);
    const { firstShape } = sizeGuideTableContainer.dataset;

    const url = new URL(document.location);
    const shapeParam = url.searchParams.get('shape');

    const activeShape = this.isValidShapeParam(shapeParam) ? shapeParam : firstShape;
    this.setActiveShape(activeShape);
  }

  isValidShapeParam(val) {
    const { state: { slideContainers } } = this;
    return slideContainers.find(({ shape }) => shape === val);
  }

  setActiveUgcContentChangeListener() {
    const { state: { setActiveUgcContentEvent } } = this;

    this.setOnCustomEvent(
      setActiveUgcContentEvent,
      ({ detail: { shape } }) => this.setActiveShape(shape),
    );
  }

  setActiveShape(shape) {
    const { state } = this;
    if (state.activeShape === shape) return;

    const content = state.slideContainers.find((slides) => slides.shape === shape);

    this.setTitle(content.title);
    this.setSwiper(content.container);

    state.activeShape = shape;
  }

  setTitle(title) {
    const { dom: { $title } } = this;
    $title.textContent = title;
  }

  async setSwiper(slides) {
    const { dom, state } = this;

    if (!state.loadActive) {
      this.enableSkeletonLoad();
      // eslint-disable-next-line no-promise-executor-return
      await new Promise((res) => setTimeout(res, state.animationDuration));
    }

    if (state.swiper) {
      state.swiper.destroy();
      dom.$swiperWrapper.innerHTML = '';
      state.swiper = null;
    }

    dom.$swiperWrapper.innerHTML = slides.innerHTML;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Navigation],
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: true,
      navigation: {
        prevEl: dom.$prevBtn,
        nextEl: dom.$nextBtn,
      },
      breakpoints: {
        1024: {
          spaceBetween: 40,
        },
      },
    });

    this.removeSkeletonLoad();
  }

  enableSkeletonLoad() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.hideLoaderClass);
    setTimeout(() => {
      dom.$component.classList.remove(state.showClass);
      state.loadActive = true;
    }, 0);
  }

  removeSkeletonLoad() {
    const { dom, state } = this;

    dom.$component.classList.add(state.showClass);
    setTimeout(() => {
      dom.$component.classList.add(state.hideLoaderClass);
      state.loadActive = false;
    }, state.animationDuration);
  }
}
